var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDogAvatar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 37,
    fill: "#F6F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5153 30.6584V37.0012C46.5153 37.8423 46.8494 38.649 47.4442 39.2438C48.0389 39.8385 48.8456 40.1727 49.6867 40.1727H51.2724C52.9547 40.1727 54.568 39.5044 55.7575 38.3149C56.947 37.1254 57.6153 35.512 57.6153 33.8298V24.3155C57.6153 23.4744 57.2812 22.6677 56.6864 22.073C56.0916 21.4782 55.285 21.1441 54.4439 21.1441H49.6867C48.6831 21.1431 47.694 20.904 46.8007 20.4464C43.7728 18.8662 40.4162 18.0189 37.001 17.9727C33.5644 18.0089 30.1849 18.8565 27.1379 20.4464C26.261 20.887 25.2965 21.1254 24.3153 21.1441H19.5581C18.717 21.1441 17.9104 21.4782 17.3156 22.073C16.7209 22.6677 16.3867 23.4744 16.3867 24.3155V33.8298C16.3867 35.512 17.055 37.1254 18.2445 38.3149C19.434 39.5044 21.0473 40.1727 22.7296 40.1727H24.3153C25.1564 40.1727 25.9631 39.8385 26.5578 39.2438C27.1526 38.649 27.4867 37.8423 27.4867 37.0012V30.6584",
    stroke: "#43474B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2694 40.1719L50.2863 45.151C49.6815 48.231 48.0257 51.0052 45.6019 52.9994C43.178 54.9936 40.1368 56.084 36.998 56.084C33.8592 56.084 30.8179 54.9936 28.3941 52.9994C25.9703 51.0052 24.3144 48.231 23.7097 45.151L22.7266 40.1719",
    stroke: "#43474B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4141 46.5156H38.5855",
    stroke: "#43474B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDogAvatar);
export default __webpack_public_path__ + "static/media/dog-avatar.bb9122a0bf22ee00661307e99e4b4ae3.svg";
export { ForwardRef as ReactComponent };